import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const LoginPage = () => {
  const { login } = useAuth();

  return (
    <GoogleOAuthProvider clientId="936838732944-8ero7srj86en5pctqq4773svfdsf81at.apps.googleusercontent.com">
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-8">Welcome to ShortlyStat</h1>
          <GoogleLogin
            onSuccess={credentialResponse => {
              login();
            }}
            onError={() => {
              console.log('Login Failed');
            }}
          />
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginPage;
